const listOfCriteriaComponent = () =>
  import("@/views/bulkNotification/listOfCriteria.vue");
const manageNotification = () =>
  import("@/views/bulkNotification/manageNotification");
const updateManageNotification = () =>
  import("@/views/bulkNotification/updateManageNotification");

export default {
  path: "listOfCriteria",
  meta: { label: "list of criteria" },
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      meta: {
        requiresAuth: true,
      },
      component: listOfCriteriaComponent,
    },
    {
      path: "manageNotification",
      meta: {
        requiresAuth: true,
      },
      component: manageNotification,
    },
    {
      name: "updateManageNotification",
      path: "updateManageNotification/:id",
      meta: {
        requiresAuth: true,
      },
      component: updateManageNotification,
    },
  ],
};
